var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSaxophone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_893_960)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.6558 14.141H25.8593C24.5648 14.141 23.5156 15.1903 23.5156 16.4847C23.5156 17.779 24.5649 18.8283 25.8593 18.8283H37.6558C38.9503 18.8283 39.9995 17.7789 39.9995 16.4847C39.9995 15.1903 38.9503 14.141 37.6558 14.141Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.6557 21.1723H25.8591V24.5917C25.8591 26.5829 24.241 28.2034 22.2532 28.2034C20.5401 28.2034 19.0535 26.9857 18.7216 25.3333L14.9464 5.08444C14.2531 1.61578 10.7826 -0.731329 7.11657 0.208279C4.3529 0.918981 2.42236 3.52359 2.42236 6.54358V11.7977H1.17236C0.524628 11.7977 0.000488281 12.3218 0.000488281 12.9696C0.000488281 13.6173 0.524628 14.1415 1.17236 14.1415H3.59415H5.93782C6.58501 14.1415 7.10969 13.6168 7.10969 12.9696V8.20412C7.10969 7.55678 7.63438 7.03225 8.28157 7.03225C8.92875 7.03225 9.45344 7.55678 9.45344 8.20412V14.1415V16.4851H8.28157C7.63383 16.4851 7.10969 17.0093 7.10969 17.657C7.10969 18.3047 7.63383 18.8289 8.28157 18.8289H9.45344V21.1725H8.28157C7.63383 21.1725 7.10969 21.6967 7.10969 22.3444C7.10969 22.9921 7.63383 23.5163 8.28157 23.5163H9.45344V24.6882V25.86H8.28157C7.63383 25.86 7.10969 26.3842 7.10969 27.0319C7.10969 27.6796 7.63383 28.2038 8.28157 28.2038H9.6643C10.7823 34.8519 16.5496 40.0003 23.5155 40.0003H23.5361L23.947 39.9934C31.4632 39.7691 37.6558 33.1223 37.6558 25.2707L37.6557 21.1723Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_893_960"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaxophone);
export default __webpack_public_path__ + "static/media/Saxophone.19623ceccf305dd87a9aa6f451d33561.svg";
export { ForwardRef as ReactComponent };